import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from '@angular/router';
import { MessageService } from 'src/app/core/services/message.service';

const ENV = environment;
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public connexionStatus: Subject<boolean> = new Subject<boolean>();
  public connexionStatusObservable = this.connexionStatus.asObservable();

  constructor(private http: HttpClient, private helper: JwtHelperService,
    private messageService: MessageService,
    private router: Router) { }

  infosUtilisateur: any = {};

  urlRedirection: string = '';

  connexion(donnees: any): Observable <any> {
    const url = ENV.loginurl + 'auth/login';
    return this.http.post(url,donnees).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  enregistrerUtilisateur(donnees: any): Observable <Object> {
    const url = `${environment.apiurl}` + 'user/registerUser';
    donnees.flgAdministrateur = '0';
    return this.http.post(url, donnees).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  miseAJourUtilisateur(donnees: any): Observable <Object> {
    const url = `${environment.apiurl}` + 'user/miseAJourUser';
    return this.http.patch(url, donnees).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  reinitialiserMotDePasse(donnees: any): Observable <Object> {
    const url = `${environment.apiurl}` + 'auth/resetUserPwd';
    return this.http.post(url,donnees).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  changerMotDePasse(donnees: any): Observable <Object> {
    const url = `${environment.apiurl}` + 'user/changepwd';
    return this.http.patch(url,donnees).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  verifierTokenChangementMotDePasse(donnees: any): Observable <Object> {
    const url = `${environment.apiurl}` + 'auth/checkUserPwdChangeToken';
    return this.http.post(url,donnees).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  definirToken(token: string) {
    window.localStorage.removeItem('dematral_token');
    window.localStorage.setItem('dematral_token', token);
  }

  obtenirToken() {
    return window.localStorage.getItem('dematral_token') ?? undefined;
  }

  estTokenExpire() {
    var token = this.obtenirToken();
    if(token != undefined){
      const estExpire = this.helper.isTokenExpired(token);
      return estExpire;
    }else{
      return true;
    }
  }

  estConnecte(): boolean {
    const estTokenExp = this.estTokenExpire();

    if (estTokenExp) {
      this.connexionStatus.next(false);
      return false;
    } else {
      const token = this.obtenirToken();
      if(token == undefined){
        this.infosUtilisateur = this.helper.decodeToken('');
      } else {
        this.infosUtilisateur = this.helper.decodeToken(token);
      }
      this.connexionStatus.next(true);
      return true;
    }
  }

  estNonConnecte(): Observable <boolean> {
    const estTokenExp = this.estTokenExpire();
    const token = this.obtenirToken();

    if (estTokenExp) {
      this.connexionStatus.next(false);
      return new Observable<boolean>(observateur => {
        observateur.next(true);
      });
    } else {
      this.connexionStatus.next(true);
      return new Observable<boolean>(observateur => {
        observateur.next(false);
      });
    }
  }

  deconnexion() {
    window.localStorage.removeItem('dematral_token');
    this.connexionStatus.next(false);
  }

  obtenirInfosUtilisateur() {
    const token = this.obtenirToken();
    if(token)
    return this.helper.decodeToken(token);
  }

  obtenirIdUtilisateurCourant(): number | null {
    if (!this.infosUtilisateur || Object.keys(this.infosUtilisateur).length === 0) {
      this.estConnecte();
    }
    const idUtilisateur = this.obtenirIdUtilisateur();
    return idUtilisateur > 0 ? idUtilisateur : null;
  }

  obtenirUtilisateurCourant(): any | null {
    if (!this.infosUtilisateur || Object.keys(this.infosUtilisateur).length === 0) {
      const token = this.obtenirToken();
      if (token) {
        this.infosUtilisateur = this.helper.decodeToken(token);
      }
    }
    return this.infosUtilisateur && Object.keys(this.infosUtilisateur).length > 0 ? this.infosUtilisateur : null;
  }

  obtenirIdUtilisateur() : number {
    if(this.infosUtilisateur != undefined && this.infosUtilisateur != null) {
      return this.infosUtilisateur.userid == undefined ? 0 : this.infosUtilisateur.userid;
    }  else {
      if(this.urlRedirection == '') {
        return 0;
      }  else {
        this.router.navigate(['/connexion']);
        return 0;
      }
    }
  }

  obtenirUtilisateur() {
    const url = `${environment.apiurl}` + 'users/current';
    return this.http.get(url);
  }

  obtenirTypesUtilisateurs() {
    const url = `${environment.apiurl}` + 'typeuser/getTypesUsers';
    return this.http.get(url);
  }

  afficherMessageErreur(erreur: any) : string{
    if(erreur.message === '200') {
      return 'OK';
    } else {
      if(erreur.status == 0) {
        return "La requete a échoué: Contactez l'administrateur.";
      } else {
        if(erreur.message != undefined && erreur.message != '') {
          if(erreur.error != undefined && erreur.error != '') {
            return erreur.error;
          } else {
            return erreur.message;
          }
        } else {
          if(erreur.status != undefined && erreur.status != '') {
            return erreur.error;
          } else {
            return erreur;
          }
        }
      }
    }
  }

  afficherMessageErreurPaiement(erreur: any) : string{
    if(erreur.error === 'processing') {
      return 'Le paiement est en cours, Veuillez patienter ... ';
    } else if(erreur.error === 'cancelled') {
      return "La session du paiement a été annulée: Veuillez ré-essaayer.";
    } else {
      if(erreur.message != undefined && erreur.message != '') {
        if(erreur.error != undefined && erreur.error != '') {
          return erreur.error;
        } else {
          return erreur.message;
        }
      } else {
        if(erreur.status != undefined && erreur.status != '') {
          return erreur.error;
        } else {
          return erreur;
        }
      }
    }
  }

  afficherAccueil () {
    this.router.navigate(['']);
  }

}
